import React from "react";

import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";

export default function Copyright() {
  return (
    <Typography
      variant="body2"
      color="#000000"
      align="center"
      fontSize="12px !important"
      my="15px"
    >
      {"Copyright © "}
      <Link color="inherit" href="https://asqi.in/">
        ASQI
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}
